
import yup from "src/utils/yup/extensionMethods";

const AddOrChangeSchema = (translate:Function) => yup.object().shape({
	mes002Titulo: yup.string()
		.required(translate("Título é requerido")),
	mes002Identificador:yup.string()
		.nullable(),
	mes002Importancia:yup.string()
		.required(translate("Valor inválido para a importância do item"))
		.oneOf(["1","2","3","4","5"], translate("Valor inválido para a importância do item")),
	mes002IntensidadeUrg:yup.string()
		.required(translate("Valor inválido para a intensidade/urgência do item"))
		.oneOf(["1","2","3","4","5"], translate("Valor inválido para a intensidade/urgência do item")),
	mes002Tendencia:yup.string()
		.required(translate("Valor inválido para a tendência do item"))
		.oneOf(["1","2","3","4","5"], translate("Valor inválido para a tendência do item"))
});


export default AddOrChangeSchema;
